(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maison-hero"] && !Shopify.designMode) return;
  try {
    
  const heroes = document.querySelectorAll('.maison-hero__carousel');

  heroes.forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('.maison-hero__slide'));
    const controls = carousel.querySelectorAll('[data-hero-direction]');
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let intervalId;

    if (slides.length < 2) return;

    if (activeIndex < 0) activeIndex = 0;

    const showSlide = (nextIndex) => {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides[activeIndex].classList.add('is-active');
    };

    const startRotation = () => {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => showSlide(activeIndex + 1), 5000);
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const direction = control.dataset.heroDirection === 'previous' ? -1 : 1;
        showSlide(activeIndex + direction);
        startRotation();
      });
    });

    startRotation();
  });

  } catch(e) { console.error(e); }
})();
})();
